/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import * as actions from '../../../redux/actions'
import SensorComponent from '../../../components/Sensors/NotifySensorComponent'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

// components

import SpinnerLoading from 'components/Loading/SpinnerLoading'
import { Button, Switch } from '@chakra-ui/react'

export default function ManagementNotify() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const { id } = useParams()
  const dispatch = useDispatch()
  const station = useSelector((state) => state.station)
  const [currentStation, setCurrentStation] = useState()
  const me = useSelector((state) => state.me)

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(actions.stationGet(id)).then(() => {
          setIsLoading(true)
          setCurrentStation(station)
          setisFetchNewOne(false)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData() // เรียกใช้งานฟังก์ชัน async ที่สร้างขึ้น

    return () => {}
  }, [id, isFetchNewOne])

  const handleChangeSwitch = async (role, field, value, id) => {
    let data = station?.lineToken

    const payload = {
      lineToken: {
        ...data,
        [_.filter(role, (item, index) => item !== undefined)[0]]: {
          ...data[_.filter(role, (item, index) => item !== undefined)[0]],
          [field]: value,
        },
      },
    }
    // console.log('payload', data, payload, value)

    await dispatch(actions.stationPut(id, payload))
    await dispatch(actions.stationGet(id))
    setisFetchNewOne(true)
  }

  const genGroupList = (gauge, station) => {
    let priorityList = _.filter(
      station?.priority,
      (pr) => me?.role === pr?.role
    )
    let gaugeList = []
    _.map(priorityList[0]?.gauge, (prList, ind) => {
      _.map(gauge, (g, index) => {
        if (g._id === prList) {
          gaugeList.push(g)
        }
      })
    })
    //console.log('gaugeList', gaugeList, priorityList)
    return gaugeList
  }

  useEffect(() => {
    setisFetchNewOne(false)
    return () => {}
  }, [isFetchNewOne])

  const genSensorList = (orderedGauge) => {
    return _.map(station.sensors, (sensor, index) => {
      if (
        _.filter(
          orderedGauge,
          (gauge) => gauge?.sensorRefString === sensor?.refString
        ).length !== 0
      ) {
        return (
          <SensorComponent
            key={index}
            sensorData={sensor}
            gauge={
              _.filter(
                orderedGauge,
                (gauge) => gauge?.sensorRefString === sensor?.refString
              )[0]
            }
            stationData={station}
            placeToEdit="station"
            isDisabled={_.map(Object.keys(station?.lineToken), (item, ind) => {
              if (me.role === item) {
                return Object.values(station?.lineToken)[ind].autoNotify
              }
            })}
          />
        )
      } else {
        return null
      }
    })
  }

  let orderedGauge = _.orderBy(
    genGroupList(station?.gauges, station),
    'orderLevel',
    'asc'
  )

  return isLoading && station ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
              การควบคุมและแจ้งเตือน
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              จัดการควบคุมและแจ้งเตือน {station.name}
            </h2>
            <h5 className="text-base text-gray-700 font-sans">
              {station.description} | {station.location}{' '}
            </h5>
          </div>
        </div>

        <div className="flex justify-between mt-2">
          <Link to={'/notify'}>
            <Button variant="outline" size="sm">
              {t('counter.back')}
            </Button>
          </Link>
          <div className="flex flex-col items-center self-center w-1/5">
            <h4 className="text-base font-bold text-gray-700 font-sans">
              {' '}
              เปิด/ปิด การแจ้งเตือนอัตโนมัติ
            </h4>
            <Switch
              size="lg"
              defaultChecked={_.map(Object.keys(station?.lineToken), (item) => {
                if (me.role === item) {
                  return item
                }
              })}
              onChange={(e) => {
                handleChangeSwitch(
                  _.map(Object.keys(station?.lineToken), (item) => {
                    if (me.role === item) {
                      return item
                    }
                  }),
                  'autoNotify',
                  e.target.checked,
                  station._id
                )
                // handleChangeSwitch(e.target.checked, station._id)
              }}
            />
          </div>
        </div>
      </div>
      <div className="px-4 w-full">{genSensorList(orderedGauge)}</div>
    </div>
  ) : (
    <SpinnerLoading />
  )
}
